




































































import { Component, Vue,Watch } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import getUrlParam from "@/common/utils/getUrlParam";
import { resolveBoundaryValue } from '@/common/utils/format'

@Component({})
export default class ScholarshipSetting extends Vue {
  @Getter("gachaTypeParameter") gachaTypeParameter!: any;
  type: string = getUrlParam("type") as string;
  @Action("changeGachaParameter") changeGachaParameter!: Function;
  oldValue:number = this.$store.state.gachaTypeParameter.scholarship.highest

  @Watch("gachaTypeParameter.scholarship.highest")
  checkHighest(newVal:number){
    if(this.type === "reEdit" && newVal < this.oldValue){
      Vue.$toast.error("活动发布后只能增加不能减少最高奖学金");
    }
  }

  get disabled() {
    return getUrlParam('type') === 'reEdit';
  }

  get predictTimes() {
    let {most,least,highest} = this.$store.state.gachaTypeParameter.scholarship;
    let predictTimes:number = Math.round(Number(highest) / ((Number(most) + Number(least))/2));
    return predictTimes;
  }

  handleInputBlur(value: number, type: string, hasDecimal: boolean = false) {
    const _value = resolveBoundaryValue(value, hasDecimal);
    this.gachaTypeParameter.scholarship[type] = _value;
    this.changeGachaParameter(this.gachaTypeParameter)
  }
}
